import { render, staticRenderFns } from "./ConfirmReopenModal.vue?vue&type=template&id=67af6257&scoped=true&"
import script from "./ConfirmReopenModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmReopenModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmReopenModal.vue?vue&type=style&index=0&id=67af6257&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67af6257",
  null
  
)

export default component.exports